//Lazy Loading for images
document.addEventListener("DOMContentLoaded", function(){
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if("IntersectionObserver" in window){
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function(lazyImage){
      lazyImageObserver.observe(lazyImage);
    });
  }
  var show = true;

});

let lazyObserver = null;

function initLazyObserver() {
  if ("IntersectionObserver" in window) {
    lazyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove("lazy");
          lazyObserver.unobserve(img);
        }
      });
    });
  }
}

initLazyObserver();

function observeLazyImages() {
  if (!lazyObserver) return;

  const lazyImages = document.querySelectorAll("img.lazy");
  lazyImages.forEach(img => lazyObserver.observe(img));
}
//height on Iphone
document.addEventListener('DOMContentLoaded', function(){
    var w = window.innerWidth,
    h = window.innerHeight;
    document.documentElement.style.setProperty('--h', h + 'px');

    m = document.getElementById("header").offsetHeight;
    document.documentElement.style.setProperty('--m', m + 'px');
});

//height on Resize
window.addEventListener("resize", onResizeFunction);
function onResizeFunction (e){
    var w = window.innerWidth,
    h = window.innerHeight;
    document.documentElement.style.setProperty('--h', h + 'px');

    m = document.getElementById("header").offsetHeight;
    document.documentElement.style.setProperty('--m', m + 'px');
}

document.addEventListener("DOMContentLoaded", function () {

  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  // Inicializar estado visual
  document.querySelectorAll(".wishlist-btn").forEach(btn => {
    const handle = btn.dataset.productHandle;

    // Estado inicial: si ya está en wishlist → poner estrella llena
    if (wishlist.includes(handle)) {
      btn.classList.add("active");
      btn.querySelector(".wishlist-icon").textContent = "★";
    } else {
      btn.querySelector(".wishlist-icon").textContent = "☆";
    }

    // Un SOLO listener para manejar todo
    btn.addEventListener("click", () => {

      const index = wishlist.indexOf(handle);

      if (index > -1) {
        // Quitar de wishlist
        wishlist.splice(index, 1);
        btn.classList.remove("active");
        btn.querySelector(".wishlist-icon").textContent = "☆"; // vacía
      } else {
        // Agregar a wishlist
        wishlist.push(handle);
        btn.classList.add("active");
        btn.querySelector(".wishlist-icon").textContent = "★"; // llena
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});






document.addEventListener("DOMContentLoaded", function () {


const categories = document.querySelector('.categories');

if (categories.classList.contains('active')) {
  document.body.classList.add('no-scroll');
} else {
  document.body.classList.remove('no-scroll');
}

  const buyBlock = document.querySelector('.buy-block');
  if (!buyBlock) return;

  let hasActivated = false;
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function handleScroll() {
    if (!mobileQuery.matches) return; // solo mobile

    const scrollY = window.scrollY;

    if (scrollY > 100 && !hasActivated) {
      buyBlock.classList.add('vissible');
      hasActivated = true;
    }

    if (scrollY === 0) {
      buyBlock.classList.remove('vissible');
      hasActivated = false;
    }
  }

  window.addEventListener('scroll', handleScroll);

let lastScrollTop = 0;
const threshold = 60;
const $breadcrumbs = $('.breadcrumbs');

$(window).on('scroll', function () {
  const scrollTop = $(this).scrollTop();
  const diff = scrollTop - lastScrollTop;

  // Scroll hacia abajo más de 60px
  if (diff > threshold) {
    $breadcrumbs.stop(true).animate({ opacity: 0 }, 0);
    lastScrollTop = scrollTop;
  }

  // Scroll hacia arriba más de 60px
  if (diff < -threshold) {
    $breadcrumbs.stop(true).animate({ opacity: 1 }, 0);
    lastScrollTop = scrollTop;
  }
});


  const placement = document.querySelector("square-placement");
  if (!placement) return;

  function applyStyles(shadow) {
    if (!shadow) return;

    // Ocultar SVG original
    const originalSVG = shadow.querySelector("svg.color-light-jewel-afterpay");
    if (originalSVG) originalSVG.style.display = "none";

    // Ocultar boton/logo original
    const originalButton = shadow.querySelector(".afterpay-logo.brand-afterpay.logo-cashappafterpay");
    if (originalButton) originalButton.style.display = "none";

    // El texto principal AHORA es .afterpay-main-text
    const textNode = shadow.querySelector(".afterpay-main-text");
    if (textNode) {
      textNode.style.fontSize = "var(--fs)";
      textNode.style.lineHeight = "1.2";
      textNode.style.color = "#000";
      textNode.style.display = "inline-flex";
      textNode.style.alignItems = "center";
      textNode.style.gap = "0px";

      // Insertar "Afterpay" antes del texto, solo 1 vez
      let styleTag = shadow.querySelector("#afterpay-before-style");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "afterpay-before-style";
        styleTag.textContent = `
          .afterpay-main-text::after {
            content: " Afterpay";
            font-size: var(--mfs);
            font-weight: 400;
            color: #000;
            margin-left: 4px;
          }
        `;
        shadow.appendChild(styleTag);
      }
    }

    console.log("🔥 Updated Afterpay styles applied");
  }

  // Esperar a que Shadow DOM esté presente
  const interval = setInterval(() => {
    const shadow = placement.shadowRoot;
    if (!shadow) return;
    clearInterval(interval);

    applyStyles(shadow);

    // Reaplicar si Square hace cambios
if (!window.IS_DESIGN_MODE) {
  const observer = new MutationObserver(() => applyStyles(shadow));
  observer.observe(shadow, { subtree: true, childList: true });
}

  }, 200);
});

if (!window.IS_DESIGN_MODE) {
(function wait() {
  const placement = document.querySelector("square-placement");
  if (!placement) return requestAnimationFrame(wait);

  const shadow = placement.shadowRoot;
  if (!shadow) return requestAnimationFrame(wait);

  // Buscar el <p> visible que sí podemos manipular
  const paragraph = shadow.querySelector(".afterpay-paragraph");
  if (!paragraph) return requestAnimationFrame(wait);

  // Evitar duplicados
  if (shadow.querySelector("#custom-afterpay-wrapper")) return;

  // Crear contenedor envolvente
  const wrapper = document.createElement("span");
  wrapper.id = "custom-afterpay-wrapper";
  wrapper.style.display = "inline-flex";
  wrapper.style.alignItems = "center";
  wrapper.style.gap = "4px";
  wrapper.style.fontSize = "16px";
  wrapper.style.color = "#000";

  // Extraer icono + división de precio (ya renderizados por Square)
  const iconAndPrice = Array.from(paragraph.childNodes);

  // TU TEXTO PERSONALIZADO
  const customText = document.createElement("span");
  customText.textContent = "pay in 4 payments of ";

  // Insertamos tu texto + los nodos visuales 100% funcionales de Square
  wrapper.appendChild(customText);
  iconAndPrice.forEach(node => wrapper.appendChild(node));

  // Limpiamos el contenido original y ponemos tu versión
  paragraph.innerHTML = "";
  paragraph.appendChild(wrapper);

})();

}


// actions
$(document).ready(function() {

  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    if (drawer.getAttribute('aria-hidden') === 'false') {
      $('.discount').stop(true, true).slideUp(250);
    }
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  document.querySelectorAll('.quick-add-btn[aria-disabled="true"]').forEach(btn => {
  btn.classList.add('soldie');
});


  $('.close-categories').click(function(e) {
    $('.categories').toggleClass("active");
    $('.shop').removeClass("active");
  });

   $('.shop, #cart').click(function(e) {
    $('.discount').slideUp(250);
  });
     $('#cart').click(function(e) {
    $('.categories').removeClass("active");
  });

     $('.shop').click(function(e) {
    $('.categories').toggleClass("active");
  });

   $('.close-categories, .close-cart').click(function(e) {
    $('.discount').slideDown(250);
  });
  

  
  $(document).click(function(e) {
      if (!$(e.target).closest('.shop, .categories, #cart, .CartDrawer__panel, .menu').length) {
        $('.categories').removeClass('active');
        $('.shop').removeClass('active');
        $('.discount').slideDown(250);
        $('#products').css('pointer-events', 'auto');
      }
  });

  $('.shop.hidden').click(function() {
      const currentText = $(this).text().trim();
      $(this).text(currentText === 'Menu' ? 'Menu' : 'Menu');
  });

  $('.sold-out').hover(
    function() {
      $(this).text('Thank you'); // cuando haces hover
    },
    function() {
      $(this).text('Sold Out'); // cuando quitas el hover
    }
  );

  $('.read-toggle').on('click', function() {
      const $btn = $(this);
      const $desc = $btn.next('.description');
      const isExpanded = $btn.attr('aria-expanded') === 'true';
  
      if (isExpanded) {
        $desc.slideUp(100, function() {
          $desc.attr('data-collapsed', 'true');
        });
        $btn.text('Read more').attr('aria-expanded', 'false');
      } else {
        $desc.slideDown(100, function() {
          $desc.attr('data-collapsed', 'false');
        });
        $btn.text('Read less').attr('aria-expanded', 'true');
      }
  });

$('.toggle-btn').on('click', function() {
  const $block = $(this).closest('.toggle-block');
  const $icon = $(this).find('.icon');

  // Cerrar todos los que están abiertos excepto el actual
  $('.toggle-block.active').not($block).each(function() {
    $(this).removeClass('active');
    $(this).find('.toggle-content').slideUp(200);
    $(this).find('.icon').text('+');
  });

  // Toggle del bloque actual
  $block.toggleClass('active');
  $block.find('.toggle-content').slideToggle(200);

  // Icono del bloque actual
  if ($block.hasClass('active')) {
    $icon.text('–');
  } else {
    $icon.text('+');
  }
});

});


document.addEventListener('DOMContentLoaded', function () {
  const categories = document.querySelector('.categories');
  if (!categories) return;

  setInterval(function () {
    document.body.classList.toggle(
      'no-scroll',
      categories.classList.contains('active')
    );
  }, 100);
});
